<template>
    <div id="app" ref="app">
        <div class="mobile-orientation"></div>
        <div id="app-content" v-if="state.dataLoaded && state.appLoaded">
            <Header></Header>
            <Application></Application>
        </div>
        <Loader v-if="!state.appLoaded"></Loader>
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>

import Header from '@/components/Header.vue'
import Loader from '@/components/Loader.vue'
import Application from '@/components/Application.vue'

import Data from '@/data/data.js'
import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'

import GL from '@/views/GL/GL.js'
import FontTransitions from '@/views/GL/FontTransitions.js'

export default {
    name: 'app',
    
    components: {
        Header,
        Loader,
        Application
    },

    data() {
        return {
            state: Store.state,
        }
    },
    created(){
        this._onTransitionLoaded = this.onTransitionLoaded.bind(this);
        this.t0 = performance.now()
        this.t1 = 0
        this.loaded = 0;
    },
    mounted() {
        GL.init(this.$refs.canvas);
        this.loadTransitions();

        window.addEventListener('orientationchange', (_e) => {
            if(Store.isTablet) window.location.reload();
        })

        if( Store.isTouch ) {
            document.querySelector('body').classList.add('no-overscroll')
        }
    },

    methods: {
        initGL: function(){
        },

        loadTransitions(){
            const PATH = `/fonts/msdf/Dillinger_Transition`;

            FontTransitions.setRendererPreload(GL.renderer);

            FontTransitions.addFontTransition('Bold_to_Light',
                [
                    {
                        json: `${PATH}/Bold_to_Light/900.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/900.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/800.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/800.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/700.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/700.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/500.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/500.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/400.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/400.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/300.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/300.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('ThinWide_to_BoldCondensed',
                [
                    
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/900_0.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/900_0.png`
                    },
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/600_20.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/600_20.png`
                    },
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/300_40.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/300_40.png`
                    },
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/100_60.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/100_60.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('BoldWide_to_LightCondensed',
                [{
                        json: `${PATH}/BoldWide_to_LightCondensed/100_900.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/100_900.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/75_700.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/75_700.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/50_500.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/50_500.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/25_300.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/25_300.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/0_100.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/0_100.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('BoldWide_to_LightCondensed_Reverse',
                [
                    
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/0_100.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/0_100.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/25_300.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/25_300.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/50_500.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/50_500.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/75_700.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/75_700.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_LightCondensed/100_900.json`,
                        texture: `${PATH}/BoldWide_to_LightCondensed/compressed/100_900.png`
                    },
                ],
                this._onTransitionLoaded
            );
            
            //could be reduced to 2 steps potentially
            FontTransitions.addFontTransition('NormalWide_to_ThinCondensed',
                [{
                        json: `${PATH}/NormalWide_to_ThinCondensed/140_1.json`,
                        texture: `${PATH}/NormalWide_to_ThinCondensed/compressed/140_1.png`
                    },
                    {
                        json: `${PATH}/NormalWide_to_ThinCondensed/200_50.json`,
                        texture: `${PATH}/NormalWide_to_ThinCondensed/compressed/200_50.png`
                    },
                    {
                        json: `${PATH}/NormalWide_to_ThinCondensed/300_100.json`,
                        texture: `${PATH}/NormalWide_to_ThinCondensed/compressed/300_100.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('LightWide_to_ThinCondensed',
                [{
                        json: `${PATH}/LightWide_to_ThinCondensed/300_40.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/300_40.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/220_20.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/220_20.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/150_1.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/150_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('LightWide_to_ThinCondensed_Reverse',
                [   {
                        json: `${PATH}/LightWide_to_ThinCondensed/150_1.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/150_1.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/220_20.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/220_20.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/300_40.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/300_40.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('LightWide_to_ThinCondensed_Still',
                [
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/150_1.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/150_1.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/150_1.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/150_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('Mobile_Condensed',
                [
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/900_0.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/900_0.png`
                    },
                    {
                        json: `${PATH}/ThinWide_to_BoldCondensed/900_0.json`,
                        texture: `${PATH}/ThinWide_to_BoldCondensed/compressed/900_0.png`
                    },
                ],
                this._onTransitionLoaded,
                true
            );

            FontTransitions.addFontTransition('Mobile_Thin',
                [{
                        json: `${PATH}/LightWide_to_ThinCondensed/300_40.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/300_40.png`
                    },
                    {
                        json: `${PATH}/LightWide_to_ThinCondensed/300_40.json`,
                        texture: `${PATH}/LightWide_to_ThinCondensed/compressed/300_40.png`
                    },
                ],
                this._onTransitionLoaded,
                true
            );

            FontTransitions.addFontTransition('BoldNormal_to_ThinCondensed',
                [{
                        json: `${PATH}/BoldNormal_to_ThinCondensed/900_60.json`,
                        texture: `${PATH}/BoldNormal_to_ThinCondensed/compressed/900_60.png`
                    },
                    {
                        json: `${PATH}/BoldNormal_to_ThinCondensed/600_40.json`,
                        texture: `${PATH}/BoldNormal_to_ThinCondensed/compressed/600_40.png`
                    },
                    {
                        json: `${PATH}/BoldNormal_to_ThinCondensed/300_20.json`,
                        texture: `${PATH}/BoldNormal_to_ThinCondensed/compressed/300_20.png`
                    },
                    {
                        json: `${PATH}/BoldNormal_to_ThinCondensed/100_0.json`,
                        texture: `${PATH}/BoldNormal_to_ThinCondensed/compressed//100_0.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('Bold_to_Thin',
                [{
                        json: `${PATH}/Bold_to_Thin/900_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/900_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/750_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/750_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/600_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/600_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/400_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/400_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/250_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/250_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/100_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/100_60.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('BoldNormal_to_BoldCondensed',
                [{
                        json: `${PATH}/BoldNormal_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/BoldNormal_to_BoldCondensed/compressed/900_1.png`
                    },
                    {
                        json: `${PATH}/BoldNormal_to_BoldCondensed/900_30.json`,
                        texture: `${PATH}/BoldNormal_to_BoldCondensed/compressed/900_30.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/900_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/900_60.png`
                    },
                ],
                this._onTransitionLoaded
            );

             FontTransitions.addFontTransition('BoldNormal_to_BoldWide',
                [{
                        json: `${PATH}/BoldNormal_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/BoldNormal_to_BoldCondensed/compressed/900_1.png`
                    },
                    {
                        json: `${PATH}/BoldNormal_to_BoldCondensed/900_30.json`,
                        texture: `${PATH}/BoldNormal_to_BoldCondensed/compressed/900_30.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Thin/900_60.json`,
                        texture: `${PATH}/Bold_to_Thin/compressed/900_60.png`
                    },
                    {
                        json: `${PATH}/Bold_to_Light/900.json`,
                        texture: `${PATH}/Bold_to_Light/compressed/900.png`
                    },
                ],
                this._onTransitionLoaded
            );

            FontTransitions.addFontTransition('ThinCondensed_to_BoldCondensed',
                [{
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/900_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/600_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/600_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/300_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/100_1.png`
                    },
                ],
                this._onTransitionLoaded
            );


            FontTransitions.addFontTransition('ThinCondensed_to_BoldCondensed_Reverse',
                [
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/100_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/300_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/600_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/600_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/compressed/900_1.png`
                    },
                ],
                this._onTransitionLoaded
            );
            //could be smaller with 140 from NormalWide_to_ThinCondensed
            FontTransitions.addFontTransition('LightCondensed_to_ThinCondensed',
                [{
                        json: `${PATH}/LightCondensed_to_ThinCondensed/140_0.json`,
                        texture: `${PATH}/LightCondensed_to_ThinCondensed/compressed/140_0.png`
                    },
                    {
                        json: `${PATH}/LightCondensed_to_ThinCondensed/100_0.json`,
                        texture: `${PATH}/LightCondensed_to_ThinCondensed/compressed/100_0.png`
                    },
                ],
                this._onTransitionLoaded
            );
            /*
            // not called
            FontTransitions.addFontTransition('Wide_to_Condensed',
                [{
                        json: `${PATH}/Wide_to_Condensed/900_100.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_100.png`
                    },
                    {
                        json: `${PATH}/Wide_to_Condensed/900_60.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_60.png`
                    },
                    {
                        json: `${PATH}/Wide_to_Condensed/900_30.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_30.png`
                    },
                    {
                        json: `${PATH}/Wide_to_Condensed/900_1.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called
            FontTransitions.addFontTransition('Wide_to_Condensed_Reverse',
                [
                    {
                        json: `${PATH}/Wide_to_Condensed/900_1.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_1.png`
                    },
                    {
                        json: `${PATH}/Wide_to_Condensed/900_30.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_30.png`
                    },
                    {
                        json: `${PATH}/Wide_to_Condensed/900_60.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_60.png`
                    },

                    {
                        json: `${PATH}/Wide_to_Condensed/900_100.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_100.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called 
            FontTransitions.addFontTransition('Wide_to_Condensed_Still',
                [
                    {
                        json: `${PATH}/Wide_to_Condensed/900_1.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_1.png`
                    },

                    {
                        json: `${PATH}/Wide_to_Condensed/900_1.json`,
                        texture: `${PATH}/Wide_to_Condensed/900_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called
            FontTransitions.addFontTransition('BoldCondensed',
                [{
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/900_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called, old news behavior 
            FontTransitions.addFontTransition('BoldWide_to_ThinCondensed',
                [{
                        json: `${PATH}/BoldWide_to_ThinCondensed/900_100.json`,
                        texture: `${PATH}/BoldWide_to_ThinCondensed/900_100.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_ThinCondensed/600_60.json`,
                        texture: `${PATH}/BoldWide_to_ThinCondensed/600_60.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_ThinCondensed/300_30.json`,
                        texture: `${PATH}/BoldWide_to_ThinCondensed/300_30.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_ThinCondensed/100_0.json`,
                        texture: `${PATH}/BoldWide_to_ThinCondensed/100_0.png`
                    },
                ],
                this._onTransitionLoaded
            );

            //never used, old news behavior 
            FontTransitions.addFontTransition('BoldWide_to_NormalCondensed',
                [{
                        json: `${PATH}/BoldWide_to_NormalCondensed/900_100.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/900_100.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/750_60.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/750_60.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/550_30.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/550_30.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called, old news behavior
            FontTransitions.addFontTransition('BoldWide_to_NormalCondensed_Reverse',
                [
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/550_30.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/550_30.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/750_60.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/750_60.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/900_100.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/900_100.png`
                    },
                ],
                this._onTransitionLoaded
            );

            // not called, old news behavior
            FontTransitions.addFontTransition('ThinCondensed_to_NormalCondensed',
                [   
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                ],
                this._onTransitionLoaded
            );

            //not called, old news behavior
            FontTransitions.addFontTransition('ThinCondensed_to_NormalCondensed_Reverse',
                [   
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/300_1.png`
                    },
                    {
                        json: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.json`,
                        texture: `${PATH}/ThinCondensed_to_BoldCondensed/100_1.png`
                    },
                ],
                this._onTransitionLoaded
            );

            //never used, old news behavior
            FontTransitions.addFontTransition('BoldWide_to_NormalCondensed_Still',
                [{
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                    {
                        json: `${PATH}/BoldWide_to_NormalCondensed/400_0.json`,
                        texture: `${PATH}/BoldWide_to_NormalCondensed/400_0.png`
                    },
                ],
                this._onTransitionLoaded
            );
*/          
            
            this.fontToLoad = Object.keys(FontTransitions.fontList).length;
        },

        onTransitionLoaded(){
            this.loaded++;
            Store.state.loaded = this.loaded/this.fontToLoad 
            if( this.loaded >= this.fontToLoad){
                console.group('Loading infos')
                console.log('Loading fonts took ', Math.round(performance.now() - this.t0)/1000,"s");
                console.log('Fonts loaded :', this.fontToLoad);
                Store.state.transitionsLoaded = true;
                Store.state.appLoaded = Store.state.transitionsLoaded && Store.state.fontLoaded;
            }
        }
    },

    watch: {
        'state.appLoaded': function (val) {
            if(val) {
                this.initGL();
            }
        }
    }
}
</script>

<style lang="scss">
html {
    overscroll-behavior: none;
    cursor: none;
}
#app {
    width: 100%;
    height: 100%;
}
canvas{
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
}
.remove{
    z-index: -1 !important;
}

.no-overscroll {
    position: fixed;
    overflow: hidden;
}

@media screen and (min-width: 320px) and (max-width: 850px) and (orientation: landscape) {
  .mobile-orientation {
    background: url('/img/orientation_screen.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
    z-index: 1001;
    background-position: center;
  }
}

</style>
